import { render, staticRenderFns } from "./SurveyContent.vue?vue&type=template&id=08fbfb86&scoped=true&"
import script from "./SurveyContent.vue?vue&type=script&lang=js&"
export * from "./SurveyContent.vue?vue&type=script&lang=js&"
import style0 from "./SurveyContent.vue?vue&type=style&index=0&id=08fbfb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbfb86",
  null
  
)

export default component.exports